import React from "react";
import { Checkbox } from "antd";
import { TextAreaItem, SelectItem } from "../../../../Components/Items";
import { SOPORTE_TEMA } from "./fasesSoporte";

/**
 * Campos con los que el agente da de alta un pre-reporte en Jira.
 */
const FormularioAprobacionJira = ({ ticket, catalogos, valores, onCambiar }) => {
  const { tiposIncidencia = [], epics = [], prioridades = [], etiquetasDisponibles = [] } = catalogos || {};

  return (
    <>
      <div
        style={{
          fontSize: 11,
          color: SOPORTE_TEMA.textSecondary,
          textTransform: "uppercase",
          letterSpacing: 0.3,
          marginBottom: 3,
        }}
      >
        Pasos de reproducción (editables)
      </div>
      <TextAreaItem
        placeholder="(el usuario no llenó este campo)"
        rows={3}
        value={valores.pasosReproduccion}
        onChange={(e) => onCambiar("pasosReproduccion", e.target.value)}
        style={{ marginBottom: 10 }}
      />
      {tiposIncidencia.length > 0 && (
        <SelectItem
          placeholder="Tipo de incidencia en Jira"
          value={valores.tipoIncidenciaId}
          options={tiposIncidencia.map((t) => ({ value: t.id, label: t.name }))}
          onChange={(value) => onCambiar("tipoIncidenciaId", value)}
          style={{ width: "100%", marginBottom: 10 }}
        />
      )}
      <SelectItem
        placeholder="Épica (opcional)"
        allowClear
        value={valores.epicKey}
        options={epics.map((e) => ({ value: e.key, label: `${e.key} — ${e.summary}` }))}
        onChange={(value) => onCambiar("epicKey", value)}
        style={{ width: "100%", marginBottom: 10 }}
      />
      {prioridades.length > 0 && (
        <SelectItem
          placeholder="Prioridad (opcional)"
          allowClear
          value={valores.prioridadId}
          options={prioridades.map((p) => ({ value: p.id, label: p.name }))}
          onChange={(value) => onCambiar("prioridadId", value)}
          style={{ width: "100%", marginBottom: 10 }}
        />
      )}
      <SelectItem
        mode="tags"
        placeholder="Etiquetas (opcional)"
        value={valores.etiquetas}
        options={etiquetasDisponibles.map((e) => ({ value: e, label: e }))}
        onChange={(value) => onCambiar("etiquetas", value)}
        style={{ width: "100%", marginBottom: 3 }}
      />
      <div style={{ fontSize: 11, color: SOPORTE_TEMA.textSecondary, marginBottom: 10 }}>
        Para agregar una etiqueta que no esté en la lista, escríbela y presiona Enter.
      </div>
      <Checkbox
        checked={valores.incluirInfoUsuario}
        onChange={(e) => onCambiar("incluirInfoUsuario", e.target.checked)}
        style={{ marginBottom: 6, display: "flex", alignItems: "flex-start" }}
      >
        <span style={{ fontSize: 12 }}>Incluir los datos de quién reportó (usuario y empresa)</span>
      </Checkbox>
      {ticket.imagenes?.length > 0 && (
        <Checkbox
          checked={valores.adjuntarImagenesJira}
          onChange={(e) => onCambiar("adjuntarImagenesJira", e.target.checked)}
          style={{ marginBottom: 6, display: "flex", alignItems: "flex-start", marginLeft: 0 }}
        >
          <span style={{ fontSize: 12 }}>
            {ticket.imagenes.length === 1
              ? "Adjuntar la imagen del reporte"
              : `Adjuntar las ${ticket.imagenes.length} imágenes del reporte`}
          </span>
        </Checkbox>
      )}
    </>
  );
};

export default FormularioAprobacionJira;
